// var Base = require('../common/base.js');
// var getQueryStr = Base.getQueryStr;
import * as StringUtil from '../base/string.js';

import Env from '../common/env';
let UI;
if(Env.isCSR) {
    UI = {
        showLoading: function() {},
        hideLoading: function() {},
        showTips: function() {},
    };
}else{
    (function (win, doc) {
        function checkStyle(_UI) {
            var cssDom = document.getElementById('uiutil_custom_style');
            if(!cssDom) {
                var dom = document.createElement('style');
                dom.setAttribute('type', "text/css");
                dom.setAttribute('id', "uiutil_custom_style");

                var style = '.wgui-message{position:fixed;top:45%;left:50%;z-index:100003;box-sizing:border-box;padding:10px;min-height:136px;height:136px;width:136px;background-color:#404040;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:12px;background-clip:padding-box}.wgui-message.wgui-message__border-radius{border-radius:var(--wg_border_radius_toast);}.wgui-message_loading .wgui-message__icon{width:40px;height:40px;margin-bottom:12px;background-image:url(https://res.wx.qq.com/wechatgame/product/webpack/userupload/20210708/201442/done.png);background-size:40px;-webkit-animation:loading 1s steps(24,end) infinite}.wgui-message_success .wgui-message__icon{background-size:40px;width:40px;height:40px;margin-bottom:12px;}.wgui-message_fail .wgui-message__icon{background-size:40px;width:40px;height:40px;margin-bottom:12px;}.wgui-message_open{overflow:hidden;min-height:80px;width:190px;height:80px}.wgui-message_open .wgui-message__content{min-height:60px}.wgui-message_open .wgui-message__text{font-size:17px;margin-top:-10px;}.wgui-message__content{display:-webkit-box;min-height:116px;width:100%;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.wgui-message__inner{text-align:center}.wgui-message__icon{display:inline-block;width:40px;height:40px}.wgui-message__text{color:#fff;font-size:17px;line-height:24px;word-break:break-all;word-wrap:break-word;color:rgba(255,255,255,0.9);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:116px;font-family:PingFangSC-Regular;}.wgui-message__line-wrap{position:absolute;bottom:20px;left:0;width:100%;height:1px;background-color:hsla(0,0%,100%,.1)}.wgui-message__line{position:absolute;top:-2px;left:-66px;width:67.5px;height:5px;background-image:url(https://wximg.qq.com/tmt/game/dist/img/modules/wui-message/message-line.png);background-size:67.5px 5px;-webkit-animation:move 1.5s linear infinite;animation:move 1.5s linear infinite}@keyframes loading{0%{-webkit-transform:rotate3d(0,0,1,0deg);transform:rotate3d(0,0,1,0deg)}to{-webkit-transform:rotate3d(0,0,1,1turn);transform:rotate3d(0,0,1,1turn)}}@-webkit-keyframes move{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(250px);transform:translateX(250px)}}@keyframes move{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(250px);transform:translateX(250px)}}.wgui-loadmore{display:-webkit-box;width:100%;height:56px;background-color:#f2f2f2;color:#b2b2b2;font-size:14px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.wgui-loadmore__inner{padding:0 10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap!important;max-width:100%}.wgui-loadmore__icon-loading{display:inline-block;margin-top:-2px;margin-right:5px;width:16px;height:16px;background-image:url(https://wximg.qq.com/tmt/game/dist/img/modules/wui-loadmore/loadmore-icon-loading@2x.png);background-size:16px;vertical-align:middle;-webkit-animation:loading 1s steps(60,end) infinite;animation:loading 1s steps(60,end) infinite}@-webkit-keyframes loading{0%{-webkit-transform:rotate3d(0,0,1,0deg)}to{-webkit-transform:rotate3d(0,0,1,1turn)}}@keyframes loading{0%{-webkit-transform:rotate3d(0,0,1,0deg)}to{-webkit-transform:rotate3d(0,0,1,1turn)}}.wg_dark_mode .wgui-message__text{color:rgba(255,255,255,0.8);}.icon_size{background-size:40px !important;background-repeat:no-repeat;background-position:center !important}.wgui-message_success .wgui-message__icon{background-size:40px !important;opacity:.9;background-image:url(https://res.wx.qq.com/wechatgame/product/webpack/userupload/20210708/202904/done.png) !important;}.wgui-message_fail .wgui-message__icon{background-size:40px !important;opacity:.9;background-image:url(https://res.wx.qq.com/wechatgame/product/webpack/userupload/20210708/203132/warning.png) !important;}.wgui-message_info .wgui-message__icon{background-image:url(https://res.wx.qq.com/wechatgame/product/cdn/moment/deb44b05.svg) !important;}';

                dom.innerHTML = style;
                var head = document.getElementsByTagName('head')[0];
                head.appendChild(dom);
            }


            //https://
            var protocol = location.protocol,
                // styleHref = 'wximg.qq.com/tmt/game/dist/css/wgui.1.0.1.min.css?max_age=2592000',
                links = document.getElementsByTagName('link'),
                isreged = false;
            for (var i = 0, len = links.length; i < len; i++) {
                var _link = links[i].getAttribute('href');
                if (-1 != _link.indexOf('wgui') || -1 != _link.indexOf('wui')) {
                    isreged = true;
                    break;
                }
            }
            /*
            *   如果没有注册样式。则注入一下。支持https
            */
            if (false === isreged) {
                // var styleLink = document.createElement('link');
                // styleLink.setAttribute('rel', "stylesheet");
                // styleLink.setAttribute('href', protocol + '//' + styleHref);
                // var head = document.getElementsByTagName('head')[0];
                // head.appendChild(styleLink);
                isreged = true;
            }
            return isreged;
        }
        UI = {
            showLoading: function (text, cfg) {

                var that = this;
                if (false == checkStyle(that)) {
                    return;
                }
                cfg = cfg || {
                    timeout: 0,
                    txt: '请稍候',
                    needIcon: true,
                    type: 'loading', //支持loading,success,fail,open
                    times: 1,
                    seconds: 1,
                    moreTip: ''
                }
                cfg.txt = text || cfg.txt;
                cfg.needIconStyle = (typeof cfg.needIcon == 'undefined' || cfg.needIcon == true) ? '' : 'none';
                cfg.type = cfg.type || 'loading';
                cfg.showBar = cfg.showBar || false;
                cfg.moreTip = cfg.moreTip || '';
                /*
                * 如果有bar，则show bar,动画执行多少次。
                */
                cfg.times = cfg.times || 1;
                /*
                * 如果有bar，则show bar,动画要多久执行完一次。
                */
                cfg.seconds = (cfg.timeout || 1000) / 1000;
                cfg.progressBarClass = cfg.type == 'open' ? '' : 'none';
                if (cfg.type == 'open') {
                    cfg.needIconStyle = 'none';
                }
                if (cfg.moreTip == '') {
                    cfg.moreTipClass = 'wgui-d-n'
                } else {
                    cfg.moreTipClass = '';
                }
                var tpl = [
                    '<div class="wgui-message wgui-message_{type} wgui-message__border-radius">',
                    '    <div class="wgui-message__content">',
                    '        <div class="wgui-message__inner">',
                    '            <div class="icon_size wgui-message__icon " style="display:{needIconStyle}"></div>',
                    cfg.txt ? '            <div class="wgui-message__text">{txt}</div>' : '',
                    '            <div class="{moreTipClass}" style="font-size: 10px;color: #fff;line-height: 15px; margin: 3px 0;transform: scale(0.9)">{moreTip}</div>',
                    '        </div>',
                    '    </div>',
                    '    <div class="wgui-message__line-wrap" style="display:{progressBarClass}">',
                    '        <div class="wgui-message__line" style="-webkit-animation: move {seconds}s linear {times};animation: move {seconds}s linear {times};"></div>',
                    '    </div>',
                    '</div>'
                ];

                var divid = 'spinner_' + parseInt((new Date()).getTime() / 86400000);
                that.spinnerDiv = document.getElementById(divid);
                if (!that.spinnerDiv) {
                    that.spinnerDiv = document.createElement('div');
                    that.spinnerDiv.id = divid;
                    if (Env.isDarkMode) {
                        that.spinnerDiv.classList.add(`wg_dark_mode`)
                    }
                    document.body.appendChild(that.spinnerDiv);
                }
                that.spinnerDiv.style.display = 'block';

                StringUtil.insertHTMLFilterXss(
                    tpl.join('').replace(/\{(\w+)\}/g, function (m, n) {
                        return cfg[n] !== undefined ? cfg[n].toString() : m;
                    }),
                    that.spinnerDiv,
                    true
                );

                if (cfg.timeout && parseInt(cfg.timeout) > 0) {
                    setTimeout(function () {
                        that.hideLoading();
                        cfg.hideCb && cfg.hideCb.call(window);
                    }, cfg.timeout);
                }

                /**
                 * 在 ios 下有重绘问题。 
                 */
                var refreshView = document.body.offsetHeight;
            },
            hideLoading: function () {
                var that = this;
                if (that.spinnerDiv) {
                    that.spinnerDiv.style.display = 'none';
                }
            },
            showTips: function (txt, cfg) {
                var that = this;
                var obj = cfg || {
                    timeout: 1000
                };
                that.showLoading(txt, obj);
            }
        };
    })(window, document);
}
export default UI;
